// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2CIui","title":"Images45_title__3SRQW","images":"Images45_images__3jroi"};